export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/asterisk-solid-41e9cebc0a06e51ce5187c0673103df4.svg";